import { createContext } from 'react';
const defaultState = {
    isOpen: false,
    dropdownButtonRef: null,
    selectedDropdownItemIndexRef: null,
    dropdownItemsRef: null,
    id: 'store-dropdown',
};
const DropdownContext = createContext(defaultState);
export default DropdownContext;
//# sourceMappingURL=DropdownContext.js.map